'use strict';
import React from 'react';
import classNames from 'classnames';
import IconButton from '../inputs/iconButton';

/**
 * Indicates a successful action on a previous page..
 * Fixed to the top of the viewport..
 * A colored SiteNotification supporting success, warning, or error priorities is supported.
 *
 * Usage:
 *
 * ```Javascript
 * <SiteNotification type="error | success | warning" />
 * ```
 *
 * @extends {React.Component}
 * @property {String} type Renders the SiteNotification message with a suitable icon and color for the defined type.
 */
class SiteNotification extends React.Component {

  /**
   * @return {String} Component Site Notification Bar CSS classname.
   */
  getSiteNotificationBarClassName (type) {
    return classNames({
      'SiteNotification-bar': true,
      [`SiteNotification-bar--${type}`]: true
    });
  }

  /**
   * @return {String} Component Site Notification Header CSS classname.
   */
  getSiteNotificationHeaderClassName (type) {
    return classNames({
      'SiteNotification-header': true,
      [`SiteNotification-header--${type}`]: true
    });
  }

  /**
   * @return {String} Component Site Notification Content CSS classname.
   */
  getSiteNotificationContentClassName (type) {
    return classNames({
      'SiteNotification-content': true,
      [`SiteNotification-content--${type}`]: true
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, type, header, onCloseButtonClick } = this.props;
    return (
      <div className="SiteNotification">
        <div className={this.getSiteNotificationBarClassName(type)} >
          <div className="ElemRightAlign SiteNotification-closebutton">
            <div className="SiteNotification-closebutton-position">
              <IconButton
                onClick={onCloseButtonClick}
                iconClass="close" />
            </div>
          </div>
          <div className={this.getSiteNotificationHeaderClassName(type)}>
            { header }
          </div>
          <div className={this.getSiteNotificationContentClassName(type)}>
            { children }
          </div>
        </div>
      </div>
    );
  }
}
//<div className="Grid-cell--11of12" style={{display: 'block', margin: 'auto', textAlign: 'justify'}}>
/**
 * @prop {propTypes} propTypes attributes for the SiteNotification component
 */
SiteNotification.propTypes = {
  type: React.PropTypes.oneOf([
    'error', 'success', 'warning'
  ]).isRequired
};

export default SiteNotification;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/customSiteNotification.jsx